import { send } from '../../lib/send';
import { IAPI } from '../../lib/models/api';
import { LoanQuoteRequest } from '@axo/shared/data-access/types/loan_quote';

export function createLoanQuote({ url: { service: baseURL }, token }: IAPI) {
  return async ({ data }: LoanQuoteRequest): Promise<LoanQuoteRequest> =>
    send({
      baseURL,
      token,
      path: `/loan-quote`,
      method: 'POST',
      body: data,
    });
}
